import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SlickDialogModule } from "@slick-components";

import { BatchPaymentDialogComponent } from "./batch-payment-dialog.component";




@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		SlickDialogModule
	],
	declarations: [BatchPaymentDialogComponent],
	exports: [BatchPaymentDialogComponent]
})
export class BatchPaymentDialogModule { }
